import React from 'react';
import { IonIcon } from '@ionic/react';
import { documentTextOutline } from 'ionicons/icons';
import './ReportTable.css';

type Props = {
  model?: React.ReactNode[][];
  columnCount: number;
  title?: string;
  rowClassName?: (row: React.ReactNode[]) => string;
};

/** Present the existing report matrix without recalculating, sorting or formatting values. */
export default function ReportTable({ model, columnCount, title = 'Dados do relatório', rowClassName }: Props) {
  if (!model || model.length <= 1) {
    return <div className="report-empty" role="status">
      <IonIcon icon={documentTextOutline} aria-hidden="true" />
      <h2>Nenhum resultado no período</h2>
      <p>Não há dados para a data pesquisada. Altere os filtros para fazer uma nova consulta.</p>
    </div>;
  }
  const columns = Array.from({ length: columnCount }, (_, index) => index);
  return <section className="report-grid" aria-label={title}>
    <div className="report-grid-heading"><h2>{title}</h2><p>Deslize a tabela para consultar todas as colunas.</p></div>
    <div className="report-grid-scroll" tabIndex={0} role="region" aria-label={`Tabela: ${title}`}>
      <table>
        <thead><tr>{columns.map(column => <th scope="col" key={column}>{model[0][column]}</th>)}</tr></thead>
        <tbody>{model.slice(1).map((row, index) => <tr key={index} className={rowClassName?.(row)}>
          {columns.map(column => <td key={column}>{row[column]}</td>)}
        </tr>)}</tbody>
      </table>
    </div>
  </section>;
}
